// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"576":"c1dea8bf","618":"300d7da1","680":"bc746992","804":"9d455c67","868":"5533a0d7","900":"b33eb45a","940":"501a6bc6"}[chunkId] + ".chunk.js";
};